<template>
  <div>
    <div class="uk-width-1-1" v-if="initialLoad">
      <div class="uk-flex uk-flex-center uk-flex-middle uk-padding-large">
        <div data-uk-spinner="ratio: 1.5"></div>
      </div>
    </div>
    <template v-else>
      <div
        class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom"
        v-if="latestVehicles.length"
      >
        <div class="uk-card-header">
          <h3 class="uk-card-title">Neueste Fahrzeuge</h3>
        </div>
        <div class="uk-card-body">
          <ul class="uk-list uk-list-divider">
            <li v-for="vehicle in latestVehicles" :key="vehicle.id">
              <div class="uk-grid" data-uk-grid>
                <div class="uk-width-small@s" v-if="showImages">
                  <a class="uk-link-reset" href="#">
                    <router-link :to="{ name: 'vehicle-details', params: { id: vehicle.carId } }">
                      <img v-if="vehicle.images && vehicle.images.length" :src="vehicle.images[0]['400_cache']" alt="" />
                      <img
                        class="uk-width-1-1"
                        v-else
                        src="/img/placeholder.png"
                        :alt="vehicle.make + ' ' + vehicle.model"
                      />
                    </router-link>
                  </a>
                </div>
                <div class="uk-width-expand">
                  <div class="uk-grid-match uk-grid-small uk-grid-divider uk-grid" uk-grid>
                    <div class="uk-width-2-3@l">
                      <p class="uk-text-bold">
                        <router-link
                          :to="{ name: 'vehicle-details', params: { id: vehicle.carId } }"
                          class="uk-link-reset"
                        >
                          {{ vehicle.make }} {{ vehicle.model }}
                        </router-link>
                        <br /><span class="uk-text-small uk-text-normal"> {{ vehicle.edition }}</span>
                      </p>
                      <div class="margin">
                        <div class="uk-grid">
                          <div class="uk-width-1-4@s">{{ vehicle.internalfirstregdate || vehicle.firstregdate }}</div>
                          <div class="uk-width-1-2@s">
                            {{ vehicle.powerkw }} kW ({{ vehicle.powerps }} PS) |
                            {{ vehicle.fueltype }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="uk-width-expand@l uk-width-1-1 uk-text-small">
                      <component :is="pricesCardLayout" :vehicle="vehicle" />
                    </div>
                    <div class="uk-width-auto@l uk-width-1-1">
                      <router-link
                        :to="{ name: 'vehicle-details', params: { id: vehicle.carId } }"
                        class="uk-text-warning"
                        uk-icon="icon: info"
                      ></router-link>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="uk-width-1-1" v-else>
        <div class="uk-grid uk-flex-center uk-text-center" uk-grid>
          <div class="uk-width-3-4@m uk-width-1-1">
            <img class="uk-text-primary uk-margin-top" width="100" src="/img/vehicle-sale.svg" data-uk-svg />
            <div class="uk-text-large uk-text-bold uk-margin">
              Zurzeit keine Fahrzeuge vorhanden
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import VehicleService from '@/services/vehicle.service'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      latestVehicles: [],
      initialLoad: true
    }
  },
  components: {
    PricesCardFleetpool: () => import("@/components/vehicles/PricesCardFleetpool"),
    PricesCardBruening: () => import("@/components/vehicles/PricesCardBruening"),
    PricesCardDaLeo: () => import("@/components/vehicles/PricesCardDaLeo"),
    PricesCardMobCon: () => import("@/components/vehicles/PricesCardMobCon"),
    PricesCardDefault: () => import("@/components/vehicles/PricesCardDefault"),
  },
  mounted() {
    VehicleService.getLatest().then(response => {
      this.latestVehicles = response.data
      setTimeout(() => {
        this.initialLoad = false
      }, 1000)
    })
  },
  computed: {
    ...mapGetters([
      'customerTypeLabel',
      'modeLabel',
      'modePriceLabel',
      'showEndcustomerPrices',
      'showMerchantPrices',
      'mode',
      'merchantConfig',
      'tenant'
    ]),
    showImages() {
      if(this.mode !== 'merchant' && (this.merchantConfig && this.merchantConfig.general && this.merchantConfig.general.hideImages)) {
        return false
      }

      return true
    },
    pricesCardLayout() {
      if (this.tenant && (this.tenant.knumber === 'K10122' || this.tenant.knumber === 'K10151')) {
        return 'PricesCardFleetpool'
      }
      if (this.tenant && this.tenant.knumber === 'K10149') {
        return 'PricesCardBruening'
      }
      if (this.tenant && this.tenant.knumber === 'K10162') {
        return 'PricesCardDaLeo'
      }
      if (this.tenant && this.tenant.knumber === 'K10170') {
        return 'PricesCardMobCon'
      }
      return 'PricesCardDefault'
    },
  }
}
</script>
